import * as linking from "./linking";

export default linking;
